import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-un-linked-clients',
  templateUrl: './un-linked-clients.component.html',
  styleUrls: ['./un-linked-clients.component.scss']
})
export class UnLinkedClientsComponent implements OnInit {
  teamDropdown: any;
  myClasses = 'inactive';
  btnClass = 'btn-grey';
  constructor() {}

  ngOnInit() {
    this.teamDropdown = [{ name: 'Iron Ways' }, { name: 'Keyhole' }];
  }
  addClasses(ev) {
    if (this.myClasses == ev) {
      this.myClasses = 'inactive';
      this.btnClass = 'btn-grey';
    } else {
      this.myClasses = 'active';
      this.btnClass = '';
    }
  }
}
